import * as tools from './tools';
import * as experts from './experts';
import * as tickets from './tickets';

export default {
  tools,
  experts,
  tickets,
};
